import ReactModal from "react-modal";
import CheckIcon from "assets/dialog_assets/circleCheck.svg";

const C = {
  ink: "#111827",
  body: "#374151",
  sub: "#6B7280",
  line: "#E5E7EB",
  greenDark: "#047857",
  greenBg: "#ECFDF5",
  amber50: "#FFFBEB",
  amber200: "#FDE68A",
  amber600: "#D97706",
  bg: "#F9FAFB",
};

export default function OnlyConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  items,        // string[]: 누락 항목 등 리스트로 표시할 내용
  tone,         // 'warning' | 'success' | 'info' (생략 시 자동 추론)
  isCheckImg,
}) {
  const resolvedTone = tone || (isCheckImg ? "success" : items?.length ? "warning" : "info");

  return (
    <ReactModal
      isOpen={!!open}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      style={{
        overlay: {
          zIndex: 200,
          backgroundColor: "rgba(15,23,42,0.55)",
        },
        content: {
          zIndex: 250,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "calc(100% - 32px)",
          maxWidth: 360,
          height: "fit-content",
          padding: 0,
          borderRadius: 18,
          backgroundColor: "#fff",
          overflow: "hidden",
          boxShadow: "0 24px 48px rgba(0, 0, 0, 0.18)",
          border: "none",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "28px 24px 22px",
          fontFamily:
            'Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, sans-serif',
        }}
      >
        {/* 아이콘 */}
        {resolvedTone === "success" ? (
          <>
            <img src={CheckIcon} alt="" style={{ marginBottom: 14 }} />
          </>
        ) : resolvedTone === "warning" ? (
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 9999,
              background: C.amber50,
              border: `1px solid ${C.amber200}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 14,
            }}
          >
            <span
              style={{
                fontSize: 28,
                lineHeight: 1,
                color: C.amber600,
                fontWeight: 800,
              }}
              aria-hidden
            >
              !
            </span>
          </div>
        ) : null}

        {/* 타이틀 + 메시지 */}
        {title ? (
          <div
            style={{
              fontSize: 18,
              fontWeight: 800,
              color: C.ink,
              letterSpacing: "-0.02em",
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            {title}
          </div>
        ) : message && !items?.length ? (
          <div
            style={{
              fontSize: 18,
              fontWeight: 800,
              color: C.ink,
              letterSpacing: "-0.02em",
              textAlign: "center",
              lineHeight: 1.4,
              whiteSpace: "pre-line",
            }}
          >
            {message}
          </div>
        ) : null}

        {title && message && !items?.length && (
          <div
            style={{
              marginTop: 8,
              fontSize: 14,
              color: C.body,
              textAlign: "center",
              lineHeight: 1.6,
              whiteSpace: "pre-line",
            }}
          >
            {message}
          </div>
        )}

        {/* 항목 리스트 */}
        {items?.length > 0 && (
          <div
            style={{
              marginTop: 14,
              alignSelf: "stretch",
              background: C.bg,
              border: `1px solid ${C.line}`,
              borderRadius: 12,
              padding: "14px 16px",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            {items.map((it, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 8,
                  fontSize: 14,
                  color: C.ink,
                  fontWeight: 600,
                  letterSpacing: "-0.01em",
                  lineHeight: 1.5,
                }}
              >
                <span
                  style={{
                    color: C.greenDark,
                    fontWeight: 800,
                    flexShrink: 0,
                    marginTop: 1,
                  }}
                  aria-hidden
                >
                  ✓
                </span>
                <span>{it}</span>
              </div>
            ))}
          </div>
        )}

        <button
          type="button"
          onClick={() => (onConfirm ? onConfirm() : onClose && onClose())}
          style={{
            marginTop: 22,
            width: "100%",
            height: 48,
            borderRadius: 12,
            border: "none",
            background: C.greenDark,
            color: "#fff",
            fontSize: 15,
            fontWeight: 800,
            cursor: "pointer",
            letterSpacing: "-0.01em",
          }}
        >
          확인
        </button>
      </div>
    </ReactModal>
  );
}
